import DotsNavigation, { getShapes } from './dots-navigation';

export default DotsNavigation;
export { getShapes };
